
import type { PropType } from 'vue';

import {
  defineComponent,
  computed,
} from 'vue';

import useCampaignSubids from '@/composable/useCampaignSubids';

/**
 * Индивидуальная ставка кампании по субайду и кнопка блокировки/разблокировки.
 *
 * Ничего не рендерит, пока в фильтрах не выбрана ровно одна кампания: см. useCampaignSubids.
 */
export default defineComponent({
  props: {
    subidUuid: {
      type: String,
      required: true,
    },
    // Композабл передаётся целиком: его состояние общее на всю таблицу, у каждой строки своё
    // было бы и лишними запросами, и рассинхроном после блокировки
    campaignSubids: {
      type: Object as PropType<ReturnType<typeof useCampaignSubids>>,
      required: true,
    },
    iconSize: {
      type: Number,
      default: 10,
    },
  },
  setup(props) {
    const campaignId = computed((): number | null => props.campaignSubids.campaignId.value);

    const settingsLoaded = computed((): boolean => props.campaignSubids.settingsLoaded.value);

    const blocked = computed((): boolean => props.campaignSubids.subidIsBlocked(props.subidUuid));

    const bid = computed((): number | null => props.campaignSubids.subidBid(props.subidUuid));

    const bidLabel = computed((): string => props.campaignSubids.subidBidLabel.value);

    const loading = computed((): boolean => !!props.campaignSubids.subidLoading.value[props.subidUuid]);

    const toggle = (): Promise<void> => props.campaignSubids.toggleSubidBlocked(props.subidUuid);

    return {
      campaignId,
      settingsLoaded,
      blocked,
      bid,
      bidLabel,
      loading,
      toggle,
    };
  },
});
